import BaseCrud from './baseCrud';
const crud = new BaseCrud('article-category', 'article-categories');

export const state = () => ({ ...crud.state });

export const getters = {
    ...crud.getters
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions
};
